export default __webpack_public_path__ + "static/media/bn.88c8bf9a.jpg";